export const PAYOUT_SORT_BY_TYPE = {
    INVOICE_NUMBER: 'invoiceNumber',
    COST_TRANSACTIONS: 'costTransactions',
    TRANSFERRED: 'transferred',
    CREATED: 'created',
};
